import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Row, Col, Card, Form } from 'react-bootstrap';
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import QuantityModal from './QuantityModal'; // Importa il nuovo componente
import ProductImage from "./ProductImage";
import { formatNumber } from "../utils/numberFormat";
import { FaExclamationCircle, FaStickyNote, FaTrash } from 'react-icons/fa';
import {
  NOTA_MARKER,
  hasNota,
  maxNotaLength,
  ordineContieneTesto,
} from '../utils/ordineStraordinarioNota';
import {
  formatImportoPane,
  formatPrezzoPane,
  importoRigaPane,
  mostraPrezziDestinazione,
  prezzoPaneVisibile,
  totaleGiornoPane,
} from '../utils/mostraPrezziDestinazione';

const bloccoProdIconProps = {
  className: 'text-danger flex-shrink-0',
  style: { fontSize: '1rem' },
  title: "Troppo tardi per modificare l'ordine per questo giorno (tempo minimo di produzione)",
  'aria-label': "Troppo tardi per modificare l'ordine per questo giorno",
};



const OrderTable = ({ 
  ordini, 
  onAddArticle,
  dayName, // Aggiungi la prop dayName 
  onSavePlanning, // Riceve la funzione di salvataggio come prop
  onQuantityChange,
  isQuantityEditable = false, // Nuova prop per rendere dinamico il campo "Quantità"
  setMappedOrders,
  isActionsDisabled = false, // Nuova prop per disabilitare le azioni
  readOnlyWeekdayKeys = [], // Giorni (lunedi…) non editabili nel modale quantità (es. domani in fascia oraria)
  getExtraReadOnlyKeysForArticle = null, // colonne (lunedi…) non editabili in base a orebloccoprod + ORARIOPRODPANE
  getRowLockedForTodayTomorrow = null, // true = disabilita select quantità (straordinari: data in finestra lead)
  dayActivationFlags = {}, // AGGIUNTO: flags per giorni disabilitati
  destinazione = null, // AGGIUNTO: dati destinazione per fallback
  cercaDescrizione = '', // Ricerca: posiziona la vista sulla riga del prodotto con descrizione corrispondente
  hideRowActions = false // true = solo lettura: nessun Modifica/Elimina (es. anteprima straordinari in Planning)
}) => {
  const { darkMode } = useContext(ThemeContext);
  const mostraPrezzi = mostraPrezziDestinazione(destinazione);
  const tableColSpanEmpty = (hideRowActions ? 4 : 5) + (mostraPrezzi ? 2 : 0);
  const totaleGiorno = mostraPrezzi ? totaleGiornoPane(ordini) : null;
  const [showModal, setShowModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState({
    codice: '',
    descriz: '',
    noteEst: '',
    immagine: '',
  });
  const [quantities, setQuantities] = useState({
  lunedi: 0,
  martedi: 0,
  mercoledi: 0,
  giovedi: 0,
  venerdi: 0,
  sabato: 0,
  domenica: 0,
});
  const [showNotaModal, setShowNotaModal] = useState(false);
  const [articoloNota, setArticoloNota] = useState(null);
  const [notaDraft, setNotaDraft] = useState('');

  // Posiziona la vista sulla riga (desktop) o card (mobile) del prodotto trovato
  useEffect(() => {
    const testo = (cercaDescrizione || '').trim().toLowerCase();
    if (!testo) return;
    const timer = setTimeout(() => {
      const riga = document.querySelector('[data-cerca-riga="true"]');
      const card = document.querySelector('[data-cerca-card="true"]');
      // Su mobile la tabella è nascosta: scrolla la card. Su desktop le card sono nascoste: scrolla la riga.
      const target = (card && card.offsetParent !== null) ? card : riga;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 200);
    return () => clearTimeout(timer);
  }, [cercaDescrizione, ordini]);

// Funzione per gestire il click sull'immagine
  const handleImageClick = (codice, descriz, noteEst = '', immagine = '') => {
    setSelectedImage({ codice, descriz, noteEst, immagine: immagine || '' });
    setShowImageModal(true);
  };

// Funzione per inizializzare quantities
  
  const handleModifyClick = (articolo) => {
    setSelectedArticle(articolo);
    setQuantities({
      lunedi: articolo.lunedi || 0,
      martedi: articolo.martedi || 0,
      mercoledi: articolo.mercoledi || 0,
      giovedi: articolo.giovedi || 0,
      venerdi: articolo.venerdi || 0,
      sabato: articolo.sabato || 0,
      domenica: articolo.domenica || 0,
    });
    setShowModal(true)
  };

  useEffect(() => {
    console.log("Ordini ricevuti in OrderTable:", ordini);
  }, [ordini]);

  const handleDeleteArticle = (codice) => {
    if (typeof setMappedOrders !== 'function') return;
    setMappedOrders((prev) => prev.filter((order) => order.codice !== codice));
  };

  const handleOpenNota = (articolo) => {
    const maxLen = maxNotaLength(articolo.descriz);
    setArticoloNota(articolo);
    setNotaDraft(String(articolo.nota || '').slice(0, maxLen));
    setShowNotaModal(true);
  };

  const handleCloseNota = () => {
    setShowNotaModal(false);
    setArticoloNota(null);
    setNotaDraft('');
  };

  const handleConfirmNota = () => {
    if (typeof setMappedOrders !== 'function' || !articoloNota) {
      handleCloseNota();
      return;
    }
    const codice = articoloNota.codice;
    const maxLen = maxNotaLength(articoloNota.descriz);
    const nota = notaDraft.trim().slice(0, maxLen);
    setMappedOrders((prev) =>
      prev.map((order) => (order.codice === codice ? { ...order, nota } : order))
    );
    handleCloseNota();
  };

  const renderDescrizioneArticolo = (articolo) => (
    <>
      <div>{articolo.descriz}</div>
      {hasNota(articolo) && (
        <div className="small mt-1 fw-normal">{`${NOTA_MARKER}${articolo.nota}`}</div>
      )}
    </>
  );

  const renderAzioniStraordinario = (articolo, { stacked = false } = {}) => (
    <div
      className={`d-flex gap-2 align-items-stretch ${stacked ? 'flex-column' : 'flex-wrap justify-content-center'}`}
    >
      <Button
        variant="warning"
        size={stacked ? undefined : 'sm'}
        className={stacked ? 'w-100' : undefined}
        onClick={() => handleOpenNota(articolo)}
        disabled={isActionsDisabled}
      >
        {hasNota(articolo) ? 'Modifica nota' : 'Aggiungi nota'}
      </Button>
      <Button
        variant="danger"
        size={stacked ? undefined : 'sm'}
        className={stacked ? 'w-100' : undefined}
        onClick={() => handleDeleteArticle(articolo.codice)}
        disabled={isActionsDisabled}
      >
        Elimina
      </Button>
    </div>
  );

  const renderAzioniStraordinarioIcone = (articolo) => (
    <div className="order-card-azioni">
      <Button
        variant={hasNota(articolo) ? 'warning' : 'outline-secondary'}
        className="order-card-icon-btn"
        onClick={() => handleOpenNota(articolo)}
        disabled={isActionsDisabled}
        title={hasNota(articolo) ? 'Modifica nota' : 'Aggiungi nota'}
        aria-label={hasNota(articolo) ? 'Modifica nota' : 'Aggiungi nota'}
      >
        <FaStickyNote size={18} />
      </Button>
      <Button
        variant="outline-danger"
        className="order-card-icon-btn"
        onClick={() => handleDeleteArticle(articolo.codice)}
        disabled={isActionsDisabled}
        title="Elimina"
        aria-label="Elimina articolo"
      >
        <FaTrash size={16} />
      </Button>
    </div>
  );

  const notaMaxLen = articoloNota ? maxNotaLength(articoloNota.descriz) : 0;

  const renderPrezzoImportoCelle = (articolo, stileEvidenzia) => {
    if (!mostraPrezzi) return null;
    const unita = articolo.unitaMisura || articolo.unita_m || articolo.unita || '';
    const prezzoTxt = prezzoPaneVisibile(articolo.prezzo)
      ? formatPrezzoPane(articolo.prezzo, unita)
      : '';
    const importo = importoRigaPane(articolo.quantita, articolo.prezzo);
    return (
      <>
        <td className={Number(articolo.quantita) === 0 ? "text-danger" : ""} style={stileEvidenzia}>
          {prezzoTxt}
        </td>
        <td className={Number(articolo.quantita) === 0 ? "text-danger" : ""} style={stileEvidenzia}>
          {importo === null ? '' : formatImportoPane(importo)}
        </td>
      </>
    );
  };

  const unitaArticolo = (articolo) => articolo.unitaMisura || 'Pz';

  const testoQuantitaPrincipale = (articolo) => {
    const um = unitaArticolo(articolo).toLowerCase();
    if (um === 'kg') {
      return formatNumber(articolo.quantita || 0, 3);
    }
    return Math.floor(articolo.quantita || 0).toString();
  };

  const testoQuantitaConversione = (articolo) => {
    const um = unitaArticolo(articolo).toLowerCase();
    const q = Number(articolo.quantita);
    const peso = Number(articolo.peso);
    if (um === 'kg' && peso && Number.isFinite(q / peso)) {
      return `(${formatNumber(q / peso, 0)} Pz)`;
    }
    if ((um === 'pz' || um === 'n') && q * peso !== 0) {
      return `(${formatNumber(q * peso, 3)} Kg)`;
    }
    return '';
  };

  const opzioniQuantitaSelect = (articolo) => {
    const isKg = unitaArticolo(articolo).toLowerCase() === 'kg';
    let range = Number(articolo.qtaRange) || 0;
    if (range === 0) range = isKg ? 0.1 : 1;
    const min = Number(articolo.qtaMinima) || range;
    const max = Number(articolo.qtaMax) || (isKg ? 100 : 1000);
    const values = [];
    for (let v = min; v <= max; v = +(v + range).toFixed(3)) {
      values.push(isKg ? v.toFixed(3) : v.toString());
    }
    let quantitaValue = articolo.quantita;
    if (typeof quantitaValue === 'string') {
      quantitaValue = quantitaValue.replace(',', '.');
    }
    quantitaValue = Number(quantitaValue);
    const selectValue = quantitaValue === 0
      ? '0'
      : isKg
        ? quantitaValue.toFixed(3)
        : quantitaValue.toString();
    return {
      isKg,
      values,
      selectValue,
      optionExists: ['0', ...values].includes(selectValue),
    };
  };

  const renderQuantitaCardBottone = (articolo, quantityRowBlockedMobile) => {
    const conv = testoQuantitaConversione(articolo);
    const isZero = Number(articolo.quantita) === 0;
    const face = (
      <>
        <span className="order-card-quantita-valore">
          {testoQuantitaPrincipale(articolo)} {unitaArticolo(articolo)}
        </span>
        <span className="order-card-quantita-conv">{conv || '\u00a0'}</span>
        {quantityRowBlockedMobile && (
          <span className="order-card-quantita-lock">
            <FaExclamationCircle {...bloccoProdIconProps} />
          </span>
        )}
      </>
    );

    if (isQuantityEditable) {
      const { isKg, values, selectValue, optionExists } = opzioniQuantitaSelect(articolo);
      const disabled = isActionsDisabled || quantityRowBlockedMobile;
      return (
        <div className={`order-card-quantita-wrap ${isZero ? 'is-zero' : ''}`}>
          <div className={`order-card-quantita ${isZero ? 'is-zero' : ''}`} aria-hidden="true">
            {face}
          </div>
          <select
            className="order-card-quantita-select"
            value={selectValue}
            disabled={disabled}
            aria-label={`Quantità ${articolo.descriz || articolo.codice}`}
            onChange={(e) =>
              onQuantityChange(
                articolo.id,
                isKg ? parseFloat(e.target.value) : parseInt(e.target.value, 10)
              )
            }
          >
            <option value="0">0</option>
            {values.map((val) => {
              if (val === '0') return null;
              let conversionText = '';
              const peso = Number(articolo.peso) || 0;
              const numVal = Number(val);
              if (peso > 0 && numVal > 0) {
                conversionText = isKg
                  ? ` (≈ ${formatNumber((numVal / peso).toFixed(0))} pz)`
                  : ` (≈ ${formatNumber((numVal * peso).toFixed(3))} kg)`;
              }
              return (
                <option key={val} value={val}>
                  {formatNumber(val, isKg ? 3 : 0)}{conversionText}
                </option>
              );
            })}
            {!optionExists && selectValue !== '0' && (
              <option value={selectValue}>{formatNumber(selectValue, isKg ? 3 : 0)} (fuori range)</option>
            )}
          </select>
        </div>
      );
    }

    return (
      <Button
        variant={isZero ? 'outline-danger' : 'primary'}
        className="w-100 order-card-quantita"
        onClick={() => handleModifyClick(articolo)}
        disabled={isActionsDisabled}
        aria-label={`Modifica quantità ${articolo.descriz || articolo.codice}`}
      >
        {face}
      </Button>
    );
  };

  const renderPrezzoImportoMobile = (articolo) => {
    if (!mostraPrezzi) return null;
    const unita = articolo.unitaMisura || articolo.unita_m || articolo.unita || '';
    const prezzoTxt = prezzoPaneVisibile(articolo.prezzo)
      ? formatPrezzoPane(articolo.prezzo, unita)
      : '';
    const importo = importoRigaPane(articolo.quantita, articolo.prezzo);
    if (!prezzoTxt && importo === null) return null;
    return (
      <div className="mt-1">
        {prezzoTxt ? <div>{prezzoTxt}</div> : null}
        {importo === null ? null : <div>Importo: {formatImportoPane(importo)}</div>}
      </div>
    );
  };

  return (
    <>
      <Table 
        responsive 
        striped 
        bordered 
        hover 
        variant={darkMode ? 'dark' : 'light'}
        className="mb-4 d-none d-lg-table"
      >
        <thead>
          <tr>
            <th>Articolo</th>
            <th>Descrizione</th>
            {!isQuantityEditable ? (
              <th>Quantità {dayName}</th> ) : (
              <th className="text-center">Quantità</th>
            )}
            {mostraPrezzi && (
              <>
                <th>Prezzo</th>
                <th>Importo</th>
              </>
            )}
            <th className="text-center">Immagine</th>
            {!hideRowActions && <th className="text-center"></th>}
          </tr>
        </thead>
        <tbody>
          {ordini && ordini.length > 0 ? (
            ordini.map((articolo, index) => {
              const testo = (cercaDescrizione || '').trim().toLowerCase();
              const indicePrimaCorrispondenza = testo
                ? ordini.findIndex((o) => ordineContieneTesto(o, testo))
                : -1;
              const eRigaTrovata = indicePrimaCorrispondenza === index;
              const stileEvidenzia = eRigaTrovata
                ? { backgroundColor: darkMode ? '#4a3a28' : '#fff3cd' }
                : undefined;
              const quantityRowBlocked =
                typeof getRowLockedForTodayTomorrow === 'function' &&
                getRowLockedForTodayTomorrow(articolo);
              return (
              <tr
                key={articolo.id}
                data-cerca-riga={eRigaTrovata ? 'true' : undefined}
              >
                <td className={Number(articolo.quantita) === 0 ? "text-danger" : ""} style={stileEvidenzia}>
                  {articolo.codice}
                </td>
                <td className={Number(articolo.quantita) === 0 ? "text-danger" : ""} style={stileEvidenzia}>
                  {renderDescrizioneArticolo(articolo)}
                </td>
                <td className={Number(articolo.quantita) === 0 ? "text-danger" : ""} style={stileEvidenzia}>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    {isQuantityEditable ? (
                      <>
                        {(() => {
                            const isKg = (articolo.unitaMisura?.toLowerCase() === "kg");
                            let range = Number(articolo.qtaRange) || 0;
                            
                            if (range === 0) range = isKg ? 0.1 : 1;
                            const min = Number(articolo.qtaMinima) || range;
                            const max = Number(articolo.qtaMax) || (isKg ? 100 : 1000);

                            // Genera i valori disponibili come stringhe con punto decimale
                            let values = [];
                            for (let v = min; v <= max; v = +(v + range).toFixed(3)) {
                              values.push(isKg ? v.toFixed(3) : v.toString());
                            }

                            // Forza il valore della select a stringa con punto decimale
                            let quantitaValue = articolo.quantita;

                            quantitaValue = Number(quantitaValue);

                            const selectValue = quantitaValue === 0
                              ? "0"
                              : isKg
                                ? quantitaValue.toFixed(3)
                                : quantitaValue.toString();

                            const optionExists = ["0", ...values].includes(selectValue);

                            return (
                              <>
                                <select
                                  value={selectValue}
                                  onChange={e => onQuantityChange(articolo.id, isKg ? parseFloat(e.target.value) : parseInt(e.target.value, 10))}
                                  className="form-control"
                                  style={{ width: "100px" }}
                                  disabled={isActionsDisabled || quantityRowBlocked}
                                >
                                  <option value="0">0</option>
                                  {values.map(val => {
                                      let conversionText = "";
                                      const peso = Number(articolo.peso) || 0;
                                      const numVal = Number(val);
                                      if (peso > 0 && numVal > 0) {
                                        if (isKg) {
                                          const pezzi = (numVal / peso).toFixed(0);
                                          conversionText = ` (≈ ${formatNumber(pezzi)} pz)`;
                                        } else {
                                          const kg = (numVal * peso).toFixed(3);
                                          conversionText = ` (≈ ${formatNumber(kg)} kg)`;
                                        }
                                      }
                                    return val !== "0" && (
                                      <option key={val} value={val}>
                                        {formatNumber(val, isKg ? 3 : 0)}{conversionText}
                                      </option>
                                    )
                                  }
                                  )}
                                  {!optionExists && selectValue !== "0" && (
                                    <option value={selectValue}>{formatNumber(selectValue, isKg ? 3 : 0)} (fuori range)</option>
                                  )}
                                </select>
                                <span>{articolo.unitaMisura}</span>
                                {quantityRowBlocked && (
                                  <FaExclamationCircle {...bloccoProdIconProps} />
                                )}
                              </>
                            );
                          })()}
                      </>
                    ) : (
                      <>
                        <span>
                          {articolo.unitaMisura?.toLowerCase() === "kg"
                            ? (formatNumber(articolo.quantita , 3) || 0) // .toFixed(3) // Mostra 3 decimali per 'Kg'
                            : Math.floor(articolo.quantita || 0).toString() // Mostra solo interi per altre unità
                          }
                        </span>
                        <span>{articolo.unitaMisura || 'Pz'}</span>
                        {quantityRowBlocked && (
                          <FaExclamationCircle {...bloccoProdIconProps} />
                        )}
                      </>
                    )}
                    <span>
                      {articolo.unitaMisura?.toLowerCase() === "kg" && articolo.peso && isFinite(articolo.quantita / articolo.peso) ? (
                        ` (${formatNumber(articolo.quantita / articolo.peso ,0)} Pz)` // Calcola la corrispondenza in Pz
                      ) : (articolo.unitaMisura?.toLowerCase() === "pz" || articolo.unitaMisura?.toLowerCase() === "n") && (articolo.quantita * articolo.peso !== 0) ? (
                        ` (${formatNumber(articolo.quantita * articolo.peso ,3)} Kg)` // Calcola la corrispondenza in Kg
                      ) : null}
                    </span>
                  </div>
                </td>
                {renderPrezzoImportoCelle(articolo, stileEvidenzia)}
                <td className="text-center" style={stileEvidenzia}>
                  <div 
                    onClick={() =>
                      handleImageClick(
                        articolo.codice,
                        articolo.descriz,
                        articolo.note_est,
                        articolo.immagine
                      )
                    }
                    style={{ cursor: 'pointer' }}
                    title="Clicca per ingrandire l'immagine"
                  >
                    <ProductImage
                      codice={articolo.codice}
                      descriz={articolo.descriz}
                      immagine={articolo.immagine}
                    />
                  </div>
                </td>
                {!hideRowActions && (
                  <td className="text-center" style={stileEvidenzia}>
                    {!isQuantityEditable ? (
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleModifyClick(articolo)}
                        disabled={isActionsDisabled}
                      >
                        Modifica
                      </Button>
                    ) : (
                      renderAzioniStraordinario(articolo)
                    )}
                  </td>
                )}
              </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={tableColSpanEmpty} className="text-center py-3">
                Nessun articolo nell'ordine
              </td>
            </tr>
          )}
        </tbody>
        {mostraPrezzi && totaleGiorno !== null && (
          <tfoot>
            <tr>
              <td colSpan={4} className="text-end fw-bold">
                Totale del giorno
              </td>
              <td className="fw-bold">{formatImportoPane(totaleGiorno)}</td>
              <td colSpan={hideRowActions ? 1 : 2}></td>
            </tr>
          </tfoot>
        )}
      </Table>

      {/* Mobile cards: testo/azioni a sinistra, immagine a destra */}
      <Row xs={2} className="g-1 d-lg-none">
        {ordini && ordini.length > 0 ? (
          ordini.map((articolo, index) => {
            const testoCard = (cercaDescrizione || '').trim().toLowerCase();
            const indiceMatchCard = testoCard
              ? ordini.findIndex((o) => ordineContieneTesto(o, testoCard))
              : -1;
            const eCardTrovata = indiceMatchCard === index;
            const stileCardEvidenzia = eCardTrovata
              ? { backgroundColor: darkMode ? '#4a3a28' : '#fff3cd', borderColor: darkMode ? '#6b5b45' : '#e8d48b' }
              : undefined;
            const quantityRowBlockedMobile =
              typeof getRowLockedForTodayTomorrow === 'function' &&
              getRowLockedForTodayTomorrow(articolo);
            return (
            <Col xs={6} key={articolo.id} data-cerca-card={eCardTrovata ? 'true' : undefined}>
              <Card 
                className={`h-100 order-card ${darkMode ? 'bg-dark text-light' : ''}` } 
                style={stileCardEvidenzia}
              >
                <Card.Body className="order-card-body">
                  <div className="order-card-main">
                    <div className="order-card-text">
                      <div className="order-card-meta">
                        <div className={`order-card-codice ${Number(articolo.quantita) === 0 ? "text-danger" : "text-muted"}`}>
                          {articolo.codice}
                        </div>
                        {isQuantityEditable && !hideRowActions && renderAzioniStraordinarioIcone(articolo)}
                      </div>
                      <div className={`order-card-descriz fw-bold ${Number(articolo.quantita) === 0 ? " text-danger" : ""}`}>
                        {articolo.descriz}
                      </div>
                      {hasNota(articolo) ? (
                        <div className="order-card-nota">{`${NOTA_MARKER}${articolo.nota}`}</div>
                      ) : (
                        <div className="order-card-nota" aria-hidden="true">&nbsp;</div>
                      )}
                      {hideRowActions && (
                        <div className="mt-1">
                          <span>
                            {testoQuantitaPrincipale(articolo)}
                          </span>
                          <span className="ms-1">{unitaArticolo(articolo)}</span>
                          {quantityRowBlockedMobile && (
                            <span className="ms-1 d-inline-flex align-items-center">
                              <FaExclamationCircle {...bloccoProdIconProps} />
                            </span>
                          )}
                          {testoQuantitaConversione(articolo) ? (
                            <span> {testoQuantitaConversione(articolo)}</span>
                          ) : null}
                          {renderPrezzoImportoMobile(articolo)}
                        </div>
                      )}
                      {!hideRowActions && renderPrezzoImportoMobile(articolo)}
                    </div>
                    <div
                      className="order-card-img"
                      onClick={() =>
                        handleImageClick(
                          articolo.codice,
                          articolo.descriz,
                          articolo.note_est,
                          articolo.immagine
                        )
                      }
                      title="Clicca per ingrandire"
                      role="button"
                      aria-label="Ingrandisci immagine"
                    >
                      <ProductImage
                        codice={articolo.codice}
                        descriz={articolo.descriz}
                        immagine={articolo.immagine}
                        className="order-card-photo"
                        style={{
                          width: 'auto',
                          height: 'auto',
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                          padding: 0,
                        }}
                      />
                    </div>
                  </div>
                  {!hideRowActions && (
                    <div className="order-card-footer">
                      {renderQuantitaCardBottone(articolo, quantityRowBlockedMobile)}
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
            );
          })
        ) : (
          <Col>
            <p className="text-center">Nessun articolo nell'ordine</p>
          </Col>
        )}
      </Row>
      {mostraPrezzi && totaleGiorno !== null && (
        <div className="fw-bold text-end mb-3 d-lg-none px-1">
          Totale del giorno: {formatImportoPane(totaleGiorno)}
        </div>
      )}

      {onAddArticle && (
        <div className="d-flex justify-content-start mb-4">
          <Button 
            variant={darkMode ? "primary" : "success"} 
            size="sm"
            onClick={() => onAddArticle()}
            className="d-flex align-items-center"
          >
            <span className="me-1">+</span> Aggiungi articoli
          </Button>
        </div>
      )}
      
      {/* Usa il componente QuantityModal */}

      <QuantityModal 
        showModal={showModal}
        setShowModal={setShowModal}
        selectedArticle={selectedArticle}
        quantities={quantities}
        setQuantities={setQuantities}
        currentDay={dayName}
        darkMode={darkMode}
        handleSavePlanning={() => onSavePlanning(selectedArticle, quantities)} // Chiama la funzione di salvataggio
        handleDeleteArticle={handleDeleteArticle}
        dayActivationFlags={dayActivationFlags}
        destinazione={destinazione}
        readOnlyWeekdayKeys={readOnlyWeekdayKeys}
        getExtraReadOnlyKeysForArticle={getExtraReadOnlyKeysForArticle}
      />

      {/* Modal per visualizzare l'immagine ingrandita */}
      <Modal 
        show={showImageModal} 
        onHide={() => setShowImageModal(false)} 
        centered 
        size="lg"
        data-bs-theme={darkMode ? "dark" : "light"}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedImage.codice} - {selectedImage.descriz}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-4">
          <ProductImage
            codice={selectedImage.codice}
            descriz={selectedImage.descriz}
            immagine={selectedImage.immagine}
            style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
          />
          {selectedImage.noteEst && selectedImage.noteEst.trim() !== '' && (
            <div className="mt-3 p-3 bg-light rounded" style={{ textAlign: 'left' }}>
              <h6 className="mb-2 text-primary">
                <i className="fas fa-sticky-note me-2"></i>Note Magazzino:
              </h6>
              <p className="mb-0 text-dark" style={{ whiteSpace: 'pre-wrap' }}>
                {selectedImage.noteEst}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImageModal(false)}>
            <i className="fas fa-times me-2"></i>Chiudi
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showNotaModal}
        onHide={handleCloseNota}
        centered
        data-bs-theme={darkMode ? 'dark' : 'light'}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {articoloNota && hasNota(articoloNota) ? 'Modifica nota' : 'Aggiungi nota'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {articoloNota && (
            <>
              <p className="mb-2">
                <strong>Articolo:</strong> {articoloNota.codice}
              </p>
              <p className="mb-3">{articoloNota.descriz}</p>
              {notaMaxLen <= 0 ? (
                <p className="text-muted mb-0">
                  La descrizione occupa già i 150 caratteri disponibili: non resta spazio per una nota.
                </p>
              ) : (
                <Form.Group>
                  <Form.Label htmlFor="nota-straordinario">Nota</Form.Label>
                  <Form.Control
                    id="nota-straordinario"
                    as="textarea"
                    rows={3}
                    value={notaDraft}
                    maxLength={notaMaxLen}
                    onChange={(e) => setNotaDraft(e.target.value.slice(0, notaMaxLen))}
                    placeholder="Testo della nota"
                  />
                  <Form.Text>
                    {notaDraft.length}/{notaMaxLen} caratteri. Al salvataggio dell&apos;ordine
                    la nota va in descrizione come «{NOTA_MARKER.trim()}».
                  </Form.Text>
                </Form.Group>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseNota}>
            Annulla
          </Button>
          <Button variant="success" onClick={handleConfirmNota} disabled={notaMaxLen <= 0 && !notaDraft.trim()}>
            Conferma
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrderTable;